export { useUiState } from './ui.store'
export type { IMousePosition } from './uiState'
export { CURSOR, MODAL } from './uiState'
